import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { EventType, NotificationHandlerType, AddMethod } from './constants.js';

var ADD = "NOTIFICATIONS/ADD";
var REMOVE = "NOTIFICATIONS/REMOVE";
var REMOVE_ALL = "NOTIFICATIONS/REMOVE_ALL";
/**
 * Action creator for sending a notification
 * @param {Object} options Options for the notification
 * @param {string} options.title The notification title text
 * @param {string} options.eventType The type of notification
 * @param {string} options.message The notification message text
 * @param {*} options.customData Optional custom data about the notification
 * @param {number} options.expiry Optional, expiry time in milliseconds for the notification to appear
 * @param {string} options.method How the notification is added. Options are "AddTop" and "AddOrReplaceTop". Defaults to "AddOrReplaceTop"
 * @param {string | object} options.handler Optional default handler for the notification
 */

var addNotification = function addNotification(options) {
  return function (dispatch) {
    var _options$title, _options$type, _options$message, _options$primaryActio, _options$expiry, _options$method;

    return dispatch({
      type: ADD,
      id: Math.floor(Math.random() * 100000000),
      title: (_options$title = options.title) !== null && _options$title !== void 0 ? _options$title : "",
      eventType: (_options$type = options.type) !== null && _options$type !== void 0 ? _options$type : EventType.Info,
      message: (_options$message = options.message) !== null && _options$message !== void 0 ? _options$message : "",
      customData: options.customData !== undefined ? options.customData : null,
      primaryAction: (_options$primaryActio = options.primaryAction) !== null && _options$primaryActio !== void 0 ? _options$primaryActio : NotificationHandlerType.None,
      expiry: (_options$expiry = options.expiry) !== null && _options$expiry !== void 0 ? _options$expiry : 0,
      method: (_options$method = options.method) !== null && _options$method !== void 0 ? _options$method : AddMethod.AddOrReplaceTop
    });
  };
};
/**
 * Action creator for removing a single notification
 * @param {number} id The unique id of the notification event to remove
 */


var removeNotification = function removeNotification(id) {
  return function (dispatch) {
    return dispatch({
      type: REMOVE,
      id: id
    });
  };
};
/**
 * Action creator for clearing all notifications
 */


var removeAllNotifications = function removeAllNotifications() {
  return function (dispatch) {
    return dispatch({
      type: REMOVE_ALL
    });
  };
};
/**
 * Action creator for sending a success message notification
 * @param {string} message Notification message text
 * @param {Object} options Additional options for the notification
 */


var notifySuccess = function notifySuccess(message) {
  var _options$expiry2;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread2(_objectSpread2({}, options), {}, {
    message: message,
    type: EventType.Success,
    expiry: (_options$expiry2 = options.expiry) !== null && _options$expiry2 !== void 0 ? _options$expiry2 : 10000
  }));
};
/**
 * Action creator for sending an information message notification
 * @param {string} message Notification message text
 * @param {Object} options Additional options for the notification
 */


var notifyInfo = function notifyInfo(message) {
  var _options$expiry3;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread2(_objectSpread2({}, options), {}, {
    message: message,
    type: EventType.Info,
    expiry: (_options$expiry3 = options.expiry) !== null && _options$expiry3 !== void 0 ? _options$expiry3 : 10000
  }));
};
/**
 * Action creator for sending a warning message notification
 * @param {string} message Notification message text
 * @param {Object} options Additional options for the notification
 */


var notifyWarning = function notifyWarning(message) {
  var _options$expiry4;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread2(_objectSpread2({}, options), {}, {
    message: message,
    type: EventType.Warning,
    expiry: (_options$expiry4 = options.expiry) !== null && _options$expiry4 !== void 0 ? _options$expiry4 : 10000
  }));
};
/**
 * Action creator for sending an error message notification
 * @param {string} message Notification message text
 * @param {Object} options Additional options for the notification
 */


var notifyError = function notifyError(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread2(_objectSpread2({}, options), {}, {
    message: message,
    type: EventType.Error
  }));
};

export { ADD, REMOVE, REMOVE_ALL, addNotification, notifyError, notifyInfo, notifySuccess, notifyWarning, removeAllNotifications, removeNotification };
